//PanelPage
import BrandList from "../components/panel/brandslist.js";
import UptimeRegistry from "../components/panel/uptime.js";
import GetDolar from "../components/panel/getdolar.js";
import DailySalesCard from "../components/panel/DailySalesCard.js";
import WeekMonthSummary from "../components/panel/WeekMonthSummary.js";
import TopProductsToday from "../components/panel/TopProductsToday.js";
import SalesByCategory from "../components/panel/SalesByCategory.js";
// import './panelpage.css'; // CSS removed - using components' own styles

export default function PanelPage() {
    return (
        <div className="dashboard-container">
            {/* First row - Existing cards */}
            <div className="dashboard-row">
                <div className="dashboard-col-lg">
                    <BrandList />
                </div>
                <div className="dashboard-col-sm">
                    <GetDolar />
                </div>
                <div className="dashboard-col-sm">
                    <UptimeRegistry />
                </div>
            </div>

            {/* Second row - New sales analytics */}
            <div className="dashboard-row">
                <div className="dashboard-col-md">
                    <DailySalesCard />
                </div>
                <div className="dashboard-col-md">
                    <WeekMonthSummary />
                </div>
                <div className="dashboard-col-md">
                    <SalesByCategory />
                </div>
            </div>

            {/* Third row - Top products */}
            <div className="dashboard-row">
                <div className="dashboard-col-full">
                    <TopProductsToday />
                </div>
            </div>
        </div>
    )
}